var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnowDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 22.321 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.2227 7.5L5.09832 14.5M17.2227 7.5L18.3208 3.40192M17.2227 7.5L21.3208 8.59808M5.09832 14.5L1.00025 13.4019M5.09832 14.5L4.00025 18.5981M17.2226 14.4999L5.09824 7.49986M17.2226 14.4999L21.3208 13.4018M17.2226 14.4999L18.3208 18.598M5.09824 7.49986L4.00039 3.40203M5.09824 7.49986L1.00039 8.59819M11.1605 4L11.1605 18M11.1605 4L8.1605 1M11.1605 4L14.1605 1M11.1605 18L8.1605 21M11.1605 18L14.1605 21",
    stroke: "var(--stroke-0, #314158)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowDepth);
export default __webpack_public_path__ + "static/media/snow-depth.a9641ba117dfec08fc233d916cc9b89b.svg";
export { ForwardRef as ReactComponent };